import React from 'react';

import BlockBuilder from '../../BlockBuilder';
import SectionContainer from '../../SectionBuilder/SectionContainer';

const JOURNAL_GRID_ID = 'journal-card-grid-container';

const textOf = field => (typeof field?.content === 'string' ? field.content.trim() : '');

const pathOf = href => (href || '').split('?')[0].replace(/\/$/, '');

/**
 * Related stories for a journal article. Console section id:
 * `detail-journal-related-cards`.
 *
 * The section title is the category (for example "wardrobe"). Cards are the
 * story blocks from the Journal page section `journal-card-grid-container`,
 * kept when that block's heading matches the category. The article itself
 * is left out.
 *
 * @component
 * @param {Object} props Page Builder section props
 * @returns {JSX.Element|null}
 */
const RelatedJournalCards = props => {
  const {
    sectionId = 'detail-journal-related-cards',
    className,
    rootClassName,
    title,
    appearance,
    options,
  } = props;

  const category = textOf(title);
  const currentPath = pathOf(options?.pagePath);
  const journalSections = options?.journalPage?.sections || [];
  const grid = journalSections.find(section => section.sectionId === JOURNAL_GRID_ID);
  const cards = (grid?.blocks || []).filter(block => {
    const cardCategory = textOf(block?.title);
    const sameCategory =
      category && cardCategory && cardCategory.toLowerCase() === category.toLowerCase();
    const href = pathOf(block?.callToAction?.href);
    const isCurrentArticle = currentPath && href && href.endsWith(currentPath);
    return sameCategory && !isCurrentArticle;
  });

  if (!cards.length) {
    return null;
  }

  const fieldOptions = { fieldComponents: options?.fieldComponents };

  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={rootClassName}
      appearance={appearance}
      options={fieldOptions}
    >
      <header>
        <h2>Related Journals</h2>
      </header>
      <div>
        <BlockBuilder
          blocks={cards.map((block, index) => ({
            ...block,
            blockId: `${sectionId}-card-${index + 1}`,
          }))}
          sectionId={sectionId}
          responsiveImageSizes="(max-width: 767px) 100vw, 600px"
          options={options}
        />
      </div>
    </SectionContainer>
  );
};

export default RelatedJournalCards;
